module.exports = __webpack_public_path__ + "static/img/rjcp.8fc2e32b.jpg";